import React from 'react';
import { capitalize } from 'lodash';

export const FormErrors = ({formErrors}) => {
  return (
    <div className='page-error-content'>
        {Object.keys(formErrors).map((fieldName, i) => {
        if(formErrors[fieldName].length > 0){
            return (
            <p key={i}>{capitalize(fieldName)} {formErrors[fieldName]}</p>
            );      
        } else {
            return '';
        }
        })}
    </div>
  );
};

export default FormErrors;


// WEBPACK FOOTER //
// ./components/formErrors/FormErrors.js